import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ObservableRequestService } from 'app/services/observable-request.service';

import { ConstantsService } from 'app/services/constants-service';

/**
* The service for the Dashboard view.
*/
@Injectable()
export class DashboardService {
    constructor(private requestService: ObservableRequestService) { }

    fetchMyClients(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.MY_CLIENTS_LIST);
    }

    fetchMyTasks(offset: Number, maxResults: Number): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.MY_TASKS_ENDPOINT + "/" + offset + "/" + maxResults);
    }

    fetchMyReviews(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.MY_REVIEWS_LIST);
    }

    fetchMyOnboardings(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.MY_ONBOARDINGS_LIST);
    }

    fetchNews(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.NEWS_ENDPOINT);
    }

    fetchScreeningHitsForMyClients(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.MONITORING_SCREENING_HITS_DASHBOARD_MY_CLIENTS);
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.service.ts